import React, { useState } from 'react'
import { DropdownMenu } from '@paypalcorp/pp-react'
import { navigate } from 'gatsby'

const DropdownNav = ({ page }: any) => {
  const [selectedValue, setSelectedValue] = useState('')

  const options = [
    {
      primaryText: 'client-ID',
      value: 'client-ID',
      linkValue: '#link-clientid',
    },
    {
      primaryText: 'buyer-country',
      value: 'buyer-country',
      linkValue: '#link-buyercountry',
    },
    { primaryText: 'commit', value: 'commit', linkValue: '#link-commit' },
    {
      primaryText: 'components',
      value: 'components',
      linkValue: '#link-components',
    },
    { primaryText: 'currency', value: 'currency', linkValue: '#link-currency' },
    {
      primaryText: 'disable-funding',
      value: 'disable-funding',
      linkValue: '#link-disablecard',
    },
    {
      primaryText: 'enable-funding',
      value: 'enable-funding',
      linkValue: '#link-disablefunding',
    },
    {
      primaryText: 'integration-date',
      value: 'integration-date',
      linkValue: '#link-integrationdate',
    },
    { primaryText: 'intent', value: 'intent', linkValue: '#link-intent' },
    { primaryText: 'locale', value: 'locale', linkValue: '#link-locale' },
    {
      primaryText: 'merchant-ID',
      value: 'merchant-ID',
      linkValue: '#link-merchantid',
    },
    { primaryText: 'vault', value: 'vault', linkValue: '#link-vault' },
  ]
  const optionsScript = [
    {
      primaryText: 'data-csp-nonce',
      value: 'data-csp-nonce',
      linkValue: '#link-datacspnonce',
    },
    {
      primaryText: 'data-client-token',
      value: 'data-client-token',
      linkValue: '#link-dataclienttoken',
    },
    {
      primaryText: 'data-page-type',
      value: 'data-page-type',
      linkValue: '#link-datapagetype',
    },
    {
      primaryText: 'data-partner-attribution-id',
      value: 'data-partner-attribution-id',
      linkValue: '#link-datapartnerattributionid',
    },
    {
      primaryText: 'data-user-id-token',
      value: 'data-user-id-token',
      linkValue: '#link-datauseridtoken',
    },
  ]

  const handleOnChange: React.EventHandler<any> = (event: any) => {
    setSelectedValue(event.target.value)
    let target: any
    if (event.target.value.startsWith('data')) {
      target = optionsScript.find((o) => o.value === event.target.value)
    } else {
      target = options.find((o) => o.value === event.target.value)
    }

    navigate(target.linkValue)
  }

  return (
    <div style={{ width: '240px', height: '80px' }}>
      <DropdownMenu
        id="withLoader"
        label={page === 'query' ? 'Query Parameters' : 'Script Parameters'}
        style={{ maxWidth: '240px', width: '240px' }}
        options={page === 'query' ? options : optionsScript}
        value={selectedValue}
        onChange={handleOnChange}
      />
    </div>
  )
}

export default DropdownNav
